<template>
  <v-app
    id="inspire"
    style="
      background: radial-gradient(circle at top, #0a1f3b 0%, #071426 80%);
      height: 100vh;
      width: 100%;
      overflow: hidden;
    "
  >
    <v-main>
      <v-container fluid class="fill-height d-flex align-center justify-center">
        <v-card
          class="pa-6 glass-card"
          elevation="10"
          width="100%"
          max-width="420"
        >
          <!-- Judul -->
          <div class="text-center mb-6">
            <div class="pa-2 d-flex align-center justify-center">
              <v-img
                v-if="logoUrl"
                :src="logoUrl"
                contain
                max-height="50"
                max-width="200"
                class="logo-img-login"
              ></v-img>
              <v-img
                v-else
                src="/"
                contain
                max-height="50"
                max-width="200"
                class="logo-img-login"
              ></v-img>
            </div>
            <h2 class="text-h5 font-weight-bold electric-title mt-2">
              {{ title }}
            </h2>
          </div>

          <!-- Form -->
          <v-card-text>
            <v-form ref="userform">
              <v-text-field
                id="x-username"
                ref="username"
                v-model="username"
                dense
                outlined
                label="Username"
                color="cyan lighten-2"
                class="mb-4 neon-input"
                hide-details
              >
                <template v-slot:prepend-inner>
                  <v-icon color="cyan lighten-2">mdi-account</v-icon>
                </template>
              </v-text-field>

              <v-text-field
                id="x-password"
                ref="password"
                v-model="password"
                label="Password"
                dense
                outlined
                color="cyan lighten-2"
                type="password"
                class="neon-input"
                hide-details
              >
                <template v-slot:prepend-inner>
                  <v-icon color="cyan lighten-2">mdi-lock</v-icon>
                </template>
              </v-text-field>
            </v-form>
          </v-card-text>

          <!-- Tombol -->
          <v-card-actions class="justify-center">
            <v-btn
              block
              large
              color="cyan darken-2"
              class="mt-2 text-white glow-btn"
              @click="login"
            >
              <v-icon left>mdi-login</v-icon> Login
            </v-btn>
          </v-card-actions>

          <!-- Footer -->
          <div class="text-center mt-6 grey--text text--lighten-1">
            <small>⚡ Powered by Smart APJ</small>
          </div>
        </v-card>
      </v-container>
    </v-main>
  </v-app>
</template>

<style scoped>
/* Background gradasi lebih lembut */
.v-application {
  background: radial-gradient(circle at top, #0a1f3b 0%, #071426 80%);
  color: #d8faff;
}

/* Card transparan halus dengan efek lembut */
.glass-card {
  backdrop-filter: blur(18px);
  background: rgba(15, 35, 70, 0.5);
  border: 1px solid rgba(0, 255, 255, 0.2);
  border-radius: 14px;
  box-shadow: 0 0 15px rgba(0, 200, 255, 0.1);
  transition: all 0.3s ease;
}
.glass-card:hover {
  box-shadow: 0 0 20px rgba(0, 200, 255, 0.2);
}

/* Judul bercahaya lembut */
.electric-title {
  color: #00d9ff;
  font-weight: 600;
  text-shadow: 0 0 5px rgba(0, 217, 255, 0.6);
}

/* Input field dengan border lembut */
.neon-input .v-input__control {
  background: rgba(255, 255, 255, 0.06);
  border-radius: 10px;
  border: 1px solid rgba(0, 255, 255, 0.25);
  transition: all 0.25s ease;
}
.neon-input:hover .v-input__control {
  border-color: rgba(0, 255, 255, 0.5);
  box-shadow: 0 0 6px rgba(0, 255, 255, 0.15);
}
.neon-input input {
  color: #00eaff !important;
  font-weight: 500;
}
.neon-input .v-label {
  color: rgba(220, 245, 255, 0.7) !important;
}
.neon-input.v-input--is-focused .v-input__control {
  border-color: #00eaff;
  box-shadow: 0 0 8px rgba(0, 234, 255, 0.4);
}

/* Tombol transparan dengan efek hover halus */
.glow-btn {
  background: transparent !important;
  border: 1px solid rgba(0, 234, 255, 0.7);
  color: #011112 !important;
  font-weight: 600;
  box-shadow: none;
  transition: all 0.3s ease;
}
.glow-btn:hover {
  background: rgba(0, 234, 255, 0.1) !important;
  border-color: #00eaff;
  color: #00eaff !important;
  box-shadow: 0 0 12px rgba(0, 234, 255, 0.25);
  transform: scale(1.02);
}

/* Footer */
.v-card small {
  color: #b9e9f5;
  text-shadow: 0 0 3px rgba(0, 234, 255, 0.3);
}

/* Background efek lembut animasi */
.v-application::after {
  content: "";
  position: absolute;
  top: -10%;
  left: -10%;
  width: 120%;
  height: 120%;
  background: radial-gradient(
    circle at 30% 30%,
    rgba(0, 200, 255, 0.1),
    transparent 70%
  );
  animation: glowMove 6s ease-in-out infinite alternate;
  z-index: -1;
}

@keyframes glowMove {
  from {
    transform: scale(1);
    opacity: 0.4;
  }
  to {
    transform: scale(1.05);
    opacity: 0.8;
  }
}

/* Responsif */
@media (max-width: 600px) {
  .glass-card {
    padding: 2rem !important;
    background: rgba(15, 35, 70, 0.75);
  }
  .electric-title {
    font-size: 1.2rem;
  }
}
</style>

<script>
import { mapGetters } from "vuex";

export default {
  components: {},
  name: "login",
  data: () => ({
    // username: 'superadmin',
    // password: 'testadmin',
    title: "Login Smart APJ",
    username: "",
    password: "",
    error: false,
    autofillFix: false,
    actions: [
      {
        caption: "Login",
        color: "info",
        xicon: "mdi-cloud-upload",
        isText: true,
        size: "large",
      },
    ],
  }),
  computed: {
    ...mapGetters("logo", ["logoUrl"]),
  },
  methods: {
    login() {
      var me = this;
      console.log("LOGIN");
      this.$store
        .dispatch("LOGIN", {
          username: this.username,
          password: this.password,
        })
        .then((success) => {
          console.log("success", success);
          console.log("username", me.$store.getters.USERNAME);
          let pathTo = "/";
          if (me.$route.query && me.$route.query.redirect) {
            pathTo = me.$route.query.redirect;
          }
          console.log(pathTo);
          setTimeout(() => {
            me.$router.push(pathTo);
            setTimeout(() => {
              location.reload();
            }, 1000);
          }, 1000);
        })
        .catch(function (err) {
          console.log(err);
          console.log(err.response);
          if (
            typeof err.response !== "undefined" &&
            typeof err.response.data !== "undefined" &&
            typeof err.response.data.message !== "undefined"
          ) {
            alert(err.response.data.message);
          } else {
            alert("Connection Error");
          }
        });
      // .catch(error => {
      //     this.error = true;
      // })
    },
  },
  props: {
    source: String,
  },
  mounted() {
    let me = this;
    // console.log(this.$refs.username.$el)
    setTimeout(() => {
      //     window.focus()
      // console.log('username', this.$refs.username.focus())
      // me.$refs.username.$el.focus();
      // me.$refs.password.focus()
      me.$refs.username.focus();
      setTimeout(() => {
        // me.$refs.username.focus()
        me.$refs.username.$el.dispatchEvent(
          new KeyboardEvent("keydown", { key: "a" })
        );
      }, 1000);
    }, 1000);
  },
};
</script>
